module.exports = __webpack_public_path__ + "4fc3e80cc5edd4cc50c25409ea96f512.pdf";